import * as api from "services/api";
import { getErrors } from "helpers/error";
import { Callback } from "Types/Callback";
import INFSe from "Types/INFSe";
import { State } from "store/reducers";

export const GET_NFSE = "[NFSE EDIT] GET_NFSE";
export const GET_NFSE_SUCCESS = "[NFSE EDIT] GET_NFSE_SUCCESS";
export const GET_NFSE_FAILED = "[NFSE EDIT] GET_NFSE_FAILED";

export const EDIT_NFSE = "[NFSE EDIT] EDIT_NFSE";
export const EDIT_NFSE_SUCCESS = "[NFSE EDIT] EDIT_NFSE_SUCCESS";
export const EDIT_NFSE_FAILED = "[NFSE EDIT] EDIT_NFSE_FAILED";

export const SET_VALUE = "[NFSE EDIT] SET_VALUE";
export const CLEAR_VALUES = "[NFSE EDIT] CLEAR_VALUES";

export function setValue(payload: any) {
	return (dispatch: any) => {
		dispatch({ type: SET_VALUE, payload });
	};
}
export function clearValues() {
	return { type: CLEAR_VALUES };
}

export function getNFSe(id: string, callback?: Callback<INFSe>) {
	return async (dispatch: any, getState: any) => {
		dispatch({ type: GET_NFSE });

		try {
			const { login } = getState() as State;

			const response = await api.sendGet("/NFSe/" + id, {
				Authorization: `Bearer ${login.token}`
			});

			const result = await response.json();

			if (result.isValid) {
				dispatch({
					type: GET_NFSE_SUCCESS,
					payload: result.model
				});

				callback && callback(null, result.model);
			} else {
				const errors = getErrors(result.errors);

				dispatch({
					type: GET_NFSE_FAILED,
					payload: errors
				});
				callback && callback(errors);
			}
		} catch (error) {
			callback && callback(error);

			return dispatch({
				type: GET_NFSE_FAILED,
				payload: {
					error: "Connection error"
				}
			});
		}
	};
}

export function updateNFSe(callback?: Callback<INFSe>) {
	return async (dispatch: any, getState: any) => {
		dispatch({ type: EDIT_NFSE });

		try {
			const state = getState();

			const { login, nFSeEdit } = state;

			const { item } = nFSeEdit;

			const model = {
				...item
			};

			const response = await api.sendPut("/NFSe/" + item.id, model, {
				Authorization: `Bearer ${login.token}`
			});

			if (response.ok) {
				dispatch({
					type: EDIT_NFSE_SUCCESS
				});

				callback && callback();
			} else {
				const result = await response.json();

				const errors = getErrors(result.errors);

				dispatch({
					type: EDIT_NFSE_FAILED,
					payload: errors
				});
				callback && callback(errors);
			}
		} catch (error) {
			return dispatch({
				type: EDIT_NFSE_FAILED,
				payload: {
					error: "Connection error"
				}
			});
		}
	};
}
